import React, { useState } from "react"
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap"
import { Link } from "gatsby"
import { Modal } from "react-bootstrap"

import Constants from "../../constants/constants.json"
import Logo from "../../images/icon.png"
import EachDropdown from "./eachDropdown"
import ContactUs from "../ContactUs/contactUs"

import Offer from "../../images/meetrix-offer.png"

import teach from "../../images/linksImgs/teach.png"
import meet from "../../images/linksImgs/meet.png"
import screenapp from "../../images/linksImgs/screenapp.png"
import remotrix from "../../images/linksImgs/remotrix1.png"

import service1 from "../../images/linksImgs/service1.png"
import service2 from "../../images/linksImgs/service2.png"
import service3 from "../../images/linksImgs/service3.png"
import service4 from "../../images/linksImgs/service4.png"

const Header = props => {
  const [isOpen, setIsOpen] = useState(false)
  const [show, setShow] = useState(false)
  const [offerModal, setOfferModal] = useState(true)

  const handleClose = () => {
    setShow(false)
    setOfferModal(false)
  }
  const handleShow = () => setShow(true)

  const toggle = () => setIsOpen(!isOpen)
  const closeContactus = () => setShow(false)

  const products = [
    {
      title: Constants.header.product.item1.title,
      description: Constants.header.product.item1.description,
      link: "https://teach.meetrix.io",
      icon: teach,
    },
    {
      title: Constants.header.product.item2.title,
      description: Constants.header.product.item2.description,
      link: "https://meet.meetrix.io",
      icon: meet,
    },
    {
      title: Constants.header.product.item3.title,
      description: Constants.header.product.item3.description,
      link: "https://screenapp.io",
      icon: screenapp,
    },
    {
      title: Constants.header.product.item4.title,
      description: Constants.header.product.item4.description,
      link: "https://remotrix.meetrix.io/",
      icon: remotrix,
    },
  ]

  const services = [
    {
      title: Constants.header.services.item1.title,
      description: Constants.header.services.item1.description,
      link: "services/commercial-support-for-jitsi",
      icon: service1,
    },
    {
      title: Constants.header.services.item2.title,
      description: Constants.header.services.item2.description,
      link: "services/custom-communication-system",
      icon: service2,
    },
    {
      title: Constants.header.services.item4.title,
      description: Constants.header.services.item4.description,
      link: "services/sip-integration",
      icon: service4,
    },
    {
      title: Constants.header.services.item3.title,
      description: Constants.header.services.item3.description,
      link: "services/consultation-for-WebRTC-Project",
      icon: service3,
    },
  ]

  const solutions = [
    {
      title: "AWS Terraform and multi-platform Kubernetes Jitsi Infrastructure as Code",
      description: "Building a video conferencing platform never got any better! We bring to you tailor-made terraform script for installation of Jitsi meet in AWS, GCP, Microsoft Azure cloud infrastructure",
      link: "solutions/aws-terraform-and-multi-platform-kubernetes-jitsi-infrastructure-as-code",
    },
    {
      title: Constants.header.solutions.item1.title,
      description: Constants.header.solutions.item1.description,
      link: "/solutions/online-tutoring",
    },
    {
      title: Constants.header.solutions.item2.title,
      description: Constants.header.solutions.item2.description,
      link: "solutions/telemedicine",
    },
    {
      title: Constants.header.solutions.item3.title,
      description: Constants.header.solutions.item3.description,
      link: "solutions/chat-applications",
    },
    // {
    //   title: Constants.header.solutions.item4.title,
    //   description: Constants.header.solutions.item4.description,
    //   link: ''
    // },
    {
      title: Constants.header.solutions.item5.title,
      description: Constants.header.solutions.item5.description,
      link: "solutions/serverless-solutions",
    },
    // {
    //   title: Constants.header.solutions.item6.title,
    //   description: Constants.header.solutions.item6.description,
    //   link: ''
    // },
    // {
    //   title: Constants.header.solutions.item7.title,
    //   description: Constants.header.solutions.item7.description,
    //   link: ''
    // },
    // {
    //   title: Constants.header.solutions.item8.title,
    //   description: Constants.header.solutions.item8.description,
    //   link: ''
    // },
    // {
    //   title: Constants.header.solutions.item9.title,
    //   description: Constants.header.solutions.item9.description,
    //   link: ''
    // }
  ]

  const resources = [
    {
      title: "Documentation",
      description: "Official documentation of meetrix products and services",
    },
    {
      title: "Blogs",
      description:
        "Blogs written by our experts on Real time communication and related technologies",
      link: "https://meetrix.io/blog/",
    },
  ]
  return (
    <Navbar
      className="header small-font"
      color="#242D45"
      dark
      expand="md"
      justified
    >
      <NavbarBrand tag={Link} to="/">
        <img
          src={Logo}
          alt="Meetrix.IO is expertize in Jitsi Meet and WebRTC Development"
        />
      </NavbarBrand>
      <NavbarToggler onClick={toggle} />
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ml-auto" navbar>
          <NavItem>
            <NavLink tag={Link} to="/">
              Home
            </NavLink>
          </NavItem>
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
              Products
            </DropdownToggle>
            <DropdownMenu right>
              <EachDropdown data={products} title="Meetrix Products" external />
            </DropdownMenu>
          </UncontrolledDropdown>
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
              Services
            </DropdownToggle>
            <DropdownMenu right>
              <EachDropdown data={services} title="Meetrix Services" />
            </DropdownMenu>
          </UncontrolledDropdown>
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
              Solutions
            </DropdownToggle>
            <DropdownMenu right>
              <EachDropdown data={solutions} title="Meetrix Solutions" />
            </DropdownMenu>
          </UncontrolledDropdown>
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
              Resources
            </DropdownToggle>
            <DropdownMenu right>
              <EachDropdown data={resources} title="Resources" external />
            </DropdownMenu>
          </UncontrolledDropdown>
          <NavItem>
            <NavLink disabled href="">
              Events
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink tag={Link} to="/pricing">
              Pricing
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink tag={Link} to="/partners">
              Partners
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink tag={Link} to="/careers">
              Careers
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink tag={Link} to="/contact-us">
              <Button color="contact-us">Contact Us</Button>
            </NavLink>
          </NavItem>
        </Nav>
      </Collapse>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton />
        <ContactUs closeContactus={closeContactus} />
      </Modal>
      {/* <Modal size="sm" className="offer-modal" show={offerModal} onHide={handleClose}>
        <Modal.Header closeButton />
        <img src={Offer} alt="meetrix offers" />
        <div className="button-container">
          <Button color="contact-us" onClick={handleShow}>
                Contact Sales
          </Button>
        </div>
      </Modal> */}
    </Navbar>
  )
}

export default Header
